import { getLinkCuration } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetLinkCurationServiceRequest,
  GetLinkCurationServiceResponse,
} from './get-link-curation.dto';
import {
  GetLinkCurationServiceRequestDtoSchema,
  GetLinkCurationServiceResponseDtoSchema,
} from './get-link-curation.dto';

export const getLinkCurationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetLinkCurationServiceRequestDtoSchema),
    async (request: GetLinkCurationServiceRequest): Promise<GetLinkCurationServiceResponse> => {
      const response = await getLinkCuration(request);

      return response.data;
    },
    validateServiceResponse(GetLinkCurationServiceResponseDtoSchema),
  ),
);
